import { useState, useEffect, useMemo } from "react";
import {
  Grid,
  Button,
  TextField,
  Typography,
  MenuItem,
  DataGrid,
  Divider,
  TextFielDecimalNumbers,
  Autocomplete,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "../../../components";
import { FlexLayout } from "../../../layouts";
import {
  FamiliaProdutosService,
  GrupoProdutosService,
  PessoaService,
  ProdutosService,
  SessionService,
  // SessionService,
  SubfamiliaProdutosService,
  SubgrupoProdutosService,
  notification,
} from "../../../services";
import {
  responseErros,
  formatPrice,
  unformatPrice,
  voltar,
} from "../../../utils";
import { value } from "../../../helpers";
import {
  calculoLucro,
  calculoPrecoVenda,
  calculoReajuste,
} from "./add-reajuste-preco";


const ReajustePrecoView = () => {
  const [produtos, setProdutos] = useState([]);
  const [totalListaProdutos, setTotalListaProdutos] = useState(0);
  const [loading, setLoading] = useState(false);
  const [gruposOptions, setGruposOptions] = useState([]);
  const [subgruposOptions, setSubgruposOptions] = useState([]);
  const [familiasOptions, setFamiliasOptions] = useState([]);
  const [subfamiliasOptions, setSubfamiliasOptions] = useState([]);
  const [fornecedoresOptions, setFornecedoresOptions] = useState([]);
  const [filtros, setFiltros] = useState({});
  const [fatorTipo, setFatorTipo] = useState("precoVenda");
  const [fatorValor, setFatorValor] = useState(0);
  const [operacao, setOperacao] = useState("somar");
  const [configuracoes, setConfiguracoes] = useState({
    margemCalculo: "INVERSA",
  });
  const produtosService = new ProdutosService();
  const gruposProdutosService = new GrupoProdutosService();
  const subgrupoProdutosService = new SubgrupoProdutosService();
  const familiaProdutosService = new FamiliaProdutosService();
  const subfamiliaProdutosService = new SubfamiliaProdutosService();
  const pessoaService = new PessoaService();
  const sessionService = new SessionService();
  const dadosEmpresa = sessionService.getEmpresa();

  async function buscarDados() {
    buscarFornecedores();
    buscarGruposProdutos();
    buscarSubgruposProdutos();
    buscarFamiliasProdutos();
    buscarSubfamiliasProdutos();
    buscarConfiguracao();
  }

  useEffect(() => {
    buscarDados();
  }, []);

  const buscarFornecedores = () => {
    const filtro = {
      nonPaginated: true,
      tiposPessoaId: 2,
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setFornecedoresOptions(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarGruposProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    gruposProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setGruposOptions(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarSubgruposProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    subgrupoProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setSubgruposOptions(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarFamiliasProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    familiaProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setFamiliasOptions(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarSubfamiliasProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    subfamiliaProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setSubfamiliasOptions(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const colunasBase = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 35,
      valueGetter: (params) => Number(params.value, false),
    },
    { field: "descricao", headerName: "Descrição", flex: 120 },
  ];

  const colunasDinamicas = useMemo(() => {
    const colDinamicas = [];

    switch (fatorTipo) {
      case "precoCompra":
        colDinamicas.push(
          {
            field: "precoCompraAnterior",
            headerName: "Pr. Compra Ante.",
            headerAlign: "right",
            align: "right",
            flex: 80,
            valueGetter: (params) => formatPrice(params.row.precoCompra, false),
          },
          {
            field: "precoCompraAtual",
            headerName: "Pr. Compra Atual",
            headerAlign: "right",
            align: "right",
            flex: 80,
            valueGetter: (params) =>
              formatPrice(
                calculoReajuste(params.row.precoCompra, fatorValor, operacao),
                false,
              ),
          },
          {
            field: "precoCustoAnterior",
            headerName: "Pr. Custo Ante.",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => formatPrice(params.row.precoCusto, false),
          },
          {
            field: "precoCustoAtual",
            headerName: "Pr. Custo Atual",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => {
              const precoCompra = parseFloat(params.row.precoCompra) || 0;
              const precoCusto = parseFloat(params.row.precoCusto) || 0;
              if (!precoCompra) return formatPrice(precoCusto, false);
              const novoPrecoCompra = calculoReajuste(
                params.row.precoCompra,
                fatorValor,
                operacao,
              );
              const novoPrecoCusto = novoPrecoCompra * (precoCusto / precoCompra);
              return formatPrice(novoPrecoCusto, false);
            },
          },
          {
            field: "precoVendaAnterior",
            headerName: "Pr. Venda Ante.",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => formatPrice(params.row.precoVenda, false),
          },
          {
            field: "precoVendaAtual",
            headerName: "Pr. Venda Atual",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => {
              const precoCompra = parseFloat(params.row.precoCompra) || 0;
              const precoVenda = parseFloat(params.row.precoVenda) || 0;
              if (!precoCompra) return formatPrice(precoVenda, false);
              const novoPrecoCompra = calculoReajuste(
                params.row.precoCompra,
                fatorValor,
                operacao,
              );
              const novoPrecoVenda = novoPrecoCompra * (precoVenda / precoCompra);
              return formatPrice(novoPrecoVenda, false);
            },
          },
        );
        break;
      case "precoCusto":
        colDinamicas.push(
          {
            field: "precoCompraAnterior",
            headerName: "Pr. Compra Ante.",
            headerAlign: "right",
            align: "right",
            flex: 80,
            valueGetter: (params) => formatPrice(params.row.precoCompra, false),
          },
          {
            field: "precoCompraAtual",
            headerName: "Pr. Compra Atual",
            headerAlign: "right",
            align: "right",
            flex: 80,
            valueGetter: (params) => formatPrice(params.row.precoCompra, false),
          },
          {
            field: "precoCustoAnterior",
            headerName: "Pr. Custo Ante.",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => formatPrice(params.row.precoCusto, false),
          },
          {
            field: "precoCustoAtual",
            headerName: "Pr. Custo Atual",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) =>
              formatPrice(
                calculoReajuste(params.row.precoCusto, fatorValor, operacao),
                false,
              ),
          },
          {
            field: "precoVendaAnterior",
            headerName: "Pr. Venda Ante.",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => formatPrice(params.row.precoVenda, false),
          },
          {
            field: "precoVendaAtual",
            headerName: "Pr. Venda Atual",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => {
              const precoCusto = parseFloat(params.row.precoCusto) || 0;
              const precoVenda = parseFloat(params.row.precoVenda) || 0;
              if (!precoCusto) return formatPrice(precoVenda, false);
              const novoPrecoCusto = calculoReajuste(
                params.row.precoCusto,
                fatorValor,
                operacao,
              );
              const novoPrecoVenda = novoPrecoCusto * (precoVenda / precoCusto);
              return formatPrice(novoPrecoVenda, false);
            },
          },
        );
        break;
      case "precoVenda":
        colDinamicas.push(
          {
            field: "precoVendaAnterior",
            headerName: "Pr. Venda Ante.",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => formatPrice(params.row.precoVenda, false),
          },
          {
            field: "precoVendaAtual",
            headerName: "Pr. Venda Atual",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) =>
              formatPrice(
                calculoReajuste(params.row.precoVenda, fatorValor, operacao),
                false,
              ),
          },
          {
            field: "lucroAnterior",
            headerName: "Lucro Ante.",
            headerAlign: "right",
            align: "right",
            flex: 50,
            valueGetter: (params) =>
              `${
                params.row.lucroDesejado
                  ? params.row.lucroDesejado.toFixed(2)
                  : "0.00"
              }%`,
          },
          {
            field: "lucroAtual",
            headerName: "Lucro Atual",
            headerAlign: "right",
            align: "right",
            flex: 50,
            valueGetter: (params) => {
              const precoVendaAtual = calculoReajuste(
                params.row?.precoVenda,
                fatorValor,
                operacao,
              );
              return `${calculoLucro(
                precoVendaAtual,
                params.row?.precoCusto || 0,
              )}%`;
            },
          },
        );
        break;
      case "precoMedio":
        colDinamicas.push(
          {
            field: "precoMedioAnterior",
            headerName: "Pr. Médio Ante.",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => formatPrice(params.row.precoMedio, false),
          },
          {
            field: "precoMedioAtual",
            headerName: "Pr. Médio Atual",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) =>
              formatPrice(
                calculoReajuste(params.row.precoMedio, fatorValor, operacao),
                false,
              ),
          },
          {
            field: "precoVendaAnterior",
            headerName: "Pr. Venda Ante.",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => formatPrice(params.row.precoVenda, false),
          },
          {
            field: "precoVendaAtual",
            headerName: "Pr. Venda Atual",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => formatPrice(params.row.precoVenda, false),
          },
        );
        break;
      case "lucro":
        colDinamicas.push(
          {
            field: "lucroAnterior",
            headerName: "Lucro Ante.",
            headerAlign: "right",
            align: "right",
            flex: 50,
            valueGetter: (params) =>
              `${
                params.row.lucroDesejado
                  ? params.row.lucroDesejado.toFixed(2)
                  : "0.00"
              }%`,
          },
          {
            field: "lucroAtual",
            headerName: "Lucro Atual",
            headerAlign: "right",
            align: "right",
            flex: 50,
            valueGetter: (params) =>
              `${
                parseFloat(fatorValor || 0) +
                parseFloat(params.row.lucroDesejado || 0)
              }%`,
          },
          {
            field: "precoVendaAnterior",
            headerName: "Pr. Venda Ante.",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => formatPrice(params.precoVenda, false),
          },
          {
            field: "precoVendaAtual",
            headerName: "Pr. Venda Atual",
            headerAlign: "right",
            align: "right",
            flex: 75,
            valueGetter: (params) => {
              const novoLucro =
                (params.row.lucroDesejado || 0) + parseFloat(fatorValor || 0);
              const valor = calculoPrecoVenda(
                params.row.precoCusto,
                novoLucro,
                configuracoes,
              );
              return formatPrice(valor, false);
            },
          },
        );
        break;
      default:
        break;
    }

    return [...colunasBase, ...colDinamicas];
  }, [fatorTipo, fatorValor, operacao]);

  async function buscarProdutos(filtros) {
    setLoading(true);
    try {
      const filtrosComuns = {
        ...filtros,
        produtoGrade: true,
      };

      const res = await produtosService.getAll(filtrosComuns);
      if (!res.isAxiosError) {
        setTotalListaProdutos(res.data.count);
        setProdutos(res.data.rows);
      } else {
        responseErros(res);
      }
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
      notification.error("Erro ao buscar produtos.");
    } finally {
      setLoading(false);
    }
  }

  async function handleReajustar() {
    setLoading(true);
    try {
      const result = await produtosService.reajustePrecoProduto({
        fatorTipo,
        fatorValor: parseFloat(fatorValor),
        filtros: handleFiltrosAvancados(),
        operacao,
      });

      if (!result.isAxiosError) {
        notification.sucessoGenericos("Preços reajustados com sucesso!");
        resetForm();
        voltar();
      } else {
        responseErros(result);
      }
    } catch (error) {
      console.error("Erro ao aplicar reajuste:", error);
      notification.error("Erro ao aplicar reajuste.");
    } finally {
      setLoading(false);
    }
  }

  const resetForm = () => {
    setFiltros({});
    setFatorTipo("precoCompra");
    setFatorValor(0);
    setOperacao("somar");
    setProdutos([]);
    setTotalListaProdutos(0);
  };

  const buscarConfiguracao = () => {
    if (dadosEmpresa.configuracoes) {
      const data = dadosEmpresa.configuracoes;
      setConfiguracoes(data);
    }
  };

  const handleFiltrosAvancados = (filter = {}) => {
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filtros,
      ...filter,
    };
    if (
      filtrosAvancadosTemp.codigoInicial &&
      filtrosAvancadosTemp.codigoFinal
    ) {
      porIntervalo.push({
        coluna: "codigo",
        de: filtrosAvancadosTemp.codigoInicial,
        ate: filtrosAvancadosTemp.codigoFinal,
      });
    }
    delete filtrosAvancadosTemp.codigoInicial;
    delete filtrosAvancadosTemp.codigoFinal;
    for (const key in filtrosAvancadosTemp) {
      if (filtrosAvancadosTemp[key] == null) {
        delete filtrosAvancadosTemp[key];
      }
    }
    const filters = {
      ...filtrosAvancadosTemp,
      restritiva: true,
      porIntervalo,
      produtoGrade: true,
    };
    return filters;
  };

  const buscarPesquisaAvancada = async (filter) => {
    if (!Object.keys(filter).length)
      return notification.alertaGenericos("Adicione pelo menos um filtro");
    const filters = handleFiltrosAvancados(filter);
    const result = await produtosService.getAllProdutosSimples(filters);
    if (!result.isAxiosError) {
      setTotalListaProdutos(result.data.count);
      setProdutos(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscarProdutos(props.filtros);
    } else {
      buscarPesquisaAvancada(props.filtros);
    }
  };

  const handleChangeAutocomplete = (name, value) => {
    setFiltros((prevState) => ({
      ...prevState,
      [name]: value ? value.id : null,
    }));
  };

  const handleInputChange = (e) => {
    setFiltros((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <FlexLayout
      title="Reajuste de Preço"
      loading={loading}
      nonSubmit
      footerActions={
        <div className="d-flex justify-content-between gap-2 px-1">
          {/* <Button variant="contained" color="success" onClick={() => {}}>
            Visualizar Reajuste
          </Button> */}
          <Button
            variant="contained"
            color="primary"
            onClick={handleReajustar}
            disabled={!produtos.length}
          >
            Reajustar Preços
          </Button>
          <Button variant="contained" color="padrao" onClick={resetForm}>
            Cancelar
          </Button>
        </div>
      }
    >
      <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
        Filtros de Produtos
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            id="grupoProdutoId"
            name="grupoProdutoId"
            options={gruposOptions}
            autoHighlight
            getOptionLabel={(option) =>
              option.codigo ? `${option.codigo} - ${option.descricao}` : ""
            }
            noOptionsText={"Nenhum grupo de produto encontrado"}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Grupo de Produto"
                variant="outlined"
              />
            )}
            onChange={(e, value) =>
              handleChangeAutocomplete("grupoProdutoId", value)
            }
            value={value.autoComplete(gruposOptions, filtros?.grupoProdutoId)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            id="subgrupoProdutoId"
            name="subgrupoProdutoId"
            options={subgruposOptions}
            autoHighlight
            getOptionLabel={(option) =>
              option.codigo ? `${option.codigo} - ${option.descricao}` : ""
            }
            noOptionsText={"Nenhum subgrupo encontrado"}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Subgrupo de Produto"
                variant="outlined"
              />
            )}
            onChange={(e, value) =>
              handleChangeAutocomplete("subgrupoProdutoId", value)
            }
            value={value.autoComplete(
              subgruposOptions,
              filtros?.subgrupoProdutoId,
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            id="familiaProdutoId"
            name="familiaProdutoId"
            options={familiasOptions}
            autoHighlight
            getOptionLabel={(option) =>
              option.codigo ? `${option.codigo} - ${option.descricao}` : ""
            }
            noOptionsText={"Nenhuma família encontrada"}
            renderInput={(params) => (
              <TextField {...params} label="Família" variant="outlined" />
            )}
            onChange={(e, value) =>
              handleChangeAutocomplete("familiaProdutoId", value)
            }
            value={value.autoComplete(
              familiasOptions,
              filtros?.familiaProdutoId,
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            id="subfamiliaProdutoId"
            name="subfamiliaProdutoId"
            options={subfamiliasOptions}
            autoHighlight
            getOptionLabel={(option) =>
              option.codigo ? `${option.codigo} - ${option.descricao}` : ""
            }
            noOptionsText={"Nenhuma subfamília encontrada"}
            renderInput={(params) => (
              <TextField {...params} label="Subfamília" variant="outlined" />
            )}
            onChange={(e, value) =>
              handleChangeAutocomplete("subfamiliaProdutoId", value)
            }
            value={value.autoComplete(
              subfamiliasOptions,
              filtros?.subfamiliaProdutoId,
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            id="fornecedorId"
            name="fornecedorId"
            options={fornecedoresOptions}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
            renderInput={(params) => (
              <TextField {...params} label="Fornecedor" variant="outlined" />
            )}
            onChange={(e, value) =>
              handleChangeAutocomplete("fornecedorId", value)
            }
            value={value.autoComplete(
              fornecedoresOptions,
              filtros?.fornecedorId,
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Faixa de Código (Inicial)"
            name="codigoInicial"
            value={filtros.codigoInicial}
            onChange={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Faixa de Código (Final)"
            name="codigoFinal"
            value={filtros.codigoFinal}
            onChange={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => buscarPesquisaAvancada(filtros)}
            fullWidth
            sx={{ height: "52px" }}
            startIcon={
              <i
                className="ph-bold ph-magnifying-glass"
                style={{ color: "white" }}
              ></i>
            }
          >
            Buscar Produtos
          </Button>
        </Grid>
      </Grid>
      <Divider sx={{ my: 2, border: "1px solid grey", width: "100%" }} />
      <Typography variant="body2" gutterBottom sx={{ my: 2 }}>
        Opções de Reajuste
      </Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            label="Aplicar Fator em"
            value={fatorTipo}
            onChange={(e) => setFatorTipo(e.target.value)}
            fullWidth
          >
            <MenuItem value="precoCompra">Pr. Compra</MenuItem>
            <MenuItem value="precoCusto">Pr. Custo</MenuItem>
            <MenuItem value="precoVenda">Pr. Venda</MenuItem>
            <MenuItem value="precoMedio">Pr. Médio</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextFielDecimalNumbers
            id="fator"
            name="fator"
            label="Fator"
            variant="outlined"
            margin="none"
            value={fatorValor}
            onBlur={(event) => {
              setFatorValor(unformatPrice(event.target.value));
            }}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <RadioGroup
            row
            name="operacao"
            value={operacao}
            onChange={(e) => setOperacao(e.target.value)}
            sx={{
              p: 0,
              m: 0,
              width: "100%",
              justifyContent: "center",
            }}
          >
            <FormControlLabel
              value="somar"
              control={<Radio size="small" />}
              label="Somar"
              sx={{ m: 0, mr: 1 }}
            />
            <FormControlLabel
              value="subtrair"
              control={<Radio size="small" />}
              label="Subtrair"
              sx={{ m: 0 }}
            />
          </RadioGroup>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2, mb: 2, border: "1px solid grey", width: "100%" }} />
      <Typography variant="body2" gutterBottom sx={{ mt: 2, mb: 2 }}>
        Produtos para Reajuste
      </Typography>
      <DataGrid
        rows={produtos}
        columns={colunasDinamicas}
        rowCount={totalListaProdutos}
        loading={loading}
        paginationMode="server"
        editShow={false}
        deleteShow={false}
        sendServer={sendServerDatagrid}
        noFilter
        disableAcoes
        filtros={filtros}
      />
    </FlexLayout>
  );
};

export default ReajustePrecoView;
